import AnalysisContainer from '../core/AnalysisContainer';
import { TabContainer } from '../core/TabContainer';
import { PlotSyncProvider } from '../providers/PlotSyncProvider';
import Balance from './balance/Balance';
import CashFlowsPlot from './cashFlows/CashFlowsPlot';
import CharacteristicsAndCost from './CharacteristicsAndCost';
import { EmissionsAnalysis } from './lca_timeseries/EmissionsAnalysis';

export const PlantCharacteristicsSection = () => {
  const tabs = [
    {
      id: 'characteristics',
      label: 'Cost Breakdown',
      content: () => <CharacteristicsAndCost />,
    },
    {
      id: 'balance',
      label: 'Mass and Energy Balance',
      content: () => <Balance />,
    },
    {
      id: 'emissions',
      label: 'Emissions',
      content: () => <EmissionsAnalysis />,
    },
    {
      id: 'cashflows',
      label: 'Cash Flows',
      content: () => <CashFlowsPlot />,
    },
  ];

  return (
    <PlotSyncProvider paramKeys={['nodeId']}>
      <AnalysisContainer title="Plant Characteristics">
        <TabContainer tabs={tabs} defaultTab={tabs[0]?.id} />
      </AnalysisContainer>
    </PlotSyncProvider>
  );
};
